export type DefaultPanelTab = "buy-again" | "manage";

function parseDefaultPanelTab(raw: string | null | undefined): DefaultPanelTab | undefined {
  if (raw == null) return undefined;
  const v = String(raw).trim().toLowerCase();
  if (v === "buy-again" || v === "buy_again" || v === "buyagain" || v === "buy") {
    return "buy-again";
  }
  if (
    v === "manage" ||
    v === "subscriptions" ||
    v === "manage-subscriptions" ||
    v === "subscription"
  ) {
    return "manage";
  }
  return undefined;
}

declare global {
  interface Window {
    /** Optional widget config; set before the widget script runs. */
    __SOCIAL_OCEAN_BUY_AGAIN__?: {
      defaultPanelTab?: string;
      autoOpen?: boolean;
    };
  }
}

/**
 * Resolved once per page: URL `?so_panel_tab=` wins, then `data-so-panel-tab` on the widget
 * script tag, then `window.__SOCIAL_OCEAN_BUY_AGAIN__.defaultPanelTab`.
 */
export function getResolvedDefaultPanelTab(): DefaultPanelTab | undefined {
  if (typeof window === "undefined") return undefined;

  const fromUrl = parseDefaultPanelTab(
    new URLSearchParams(window.location.search).get("so_panel_tab"),
  );
  if (fromUrl) return fromUrl;

  if (typeof document !== "undefined") {
    const script = document.querySelector(
      'script[src*="social-ocean-buy-again"]',
    ) as HTMLScriptElement | null;
    if (script) {
      const fromAttr = parseDefaultPanelTab(script.getAttribute("data-so-panel-tab"));
      if (fromAttr) return fromAttr;
    }
  }

  const fromWindow = parseDefaultPanelTab(
    window.__SOCIAL_OCEAN_BUY_AGAIN__?.defaultPanelTab,
  );
  if (fromWindow) return fromWindow;

  return undefined;
}
